import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useLookups } from "@/lib/hooks";

export function DuplicateDialog({ project, onClose }) {
  const lk = useLookups();
  const qc = useQueryClient();
  const nav = useNavigate();
  const [form, setForm] = useState({ code: `${project.code}-COPIA`, name: `${project.name} (copia)`, company_id: project.company_id });
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/projects/${project.id}/duplicate`, form);
      qc.invalidateQueries({ queryKey: ["projects"] }); qc.invalidateQueries({ queryKey: ["portfolio"] });
      toast.success(`Operazione ${data.code} creata: ${data.copied.lines} voci CE, ${data.copied.units} unità, ${data.copied.financing} fonti, ${data.copied.milestones} milestone`);
      onClose(); nav(`/operazioni/${data.id}`);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const F = ({ l, k, children }) => <label className="flex flex-col gap-1 text-sm"><span className="text-xs uppercase tracking-wide text-slate-500">{l}</span>{children}</label>;
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-white max-w-lg" data-testid="duplicate-dialog">
        <DialogHeader><DialogTitle className="font-heading">Duplica operazione {project.code}</DialogTitle></DialogHeader>
        <p className="text-xs text-slate-600">Crea una nuova operazione <b>In valutazione</b> copiando anagrafica, l'ultimo Preventivo/Revisione come <b>Preventivo 1 in bozza</b>, le unità con pertinenze (prezzi finali, stati commerciali e date di vendita azzerati), le fonti di finanziamento (erogato/rimborsato azzerati) e le milestone previste. Non vengono copiati movimenti, pagamenti, documenti, cash flow, scenari, imposte e membri.</p>
        <div className="grid gap-3">
          <F l="Nuovo codice"><input value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value })} className="input-editable" data-testid="duplicate-code" /></F>
          <F l="Nuovo nome"><input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="input-editable" data-testid="duplicate-name" /></F>
          <F l="Società"><select value={form.company_id} onChange={(e) => setForm({ ...form, company_id: e.target.value })} className="input-editable" data-testid="duplicate-company">{(lk.companies || []).map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}</select></F>
        </div>
        <div className="flex justify-end gap-2"><Button variant="outline" onClick={onClose}>Annulla</Button><Button onClick={submit} disabled={busy || !form.code.trim() || !form.name.trim()} data-testid="duplicate-confirm">Duplica</Button></div>
      </DialogContent>
    </Dialog>
  );
}
